import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';

export const NewTag = () => {
  const { t } = useTranslation('tiles');

  return (
    <TagWrapper>
      <Text color="white" variant="small4">
        {t('newTag')}
      </Text>
    </TagWrapper>
  );
};

const TagWrapper = styled.div`
  padding: 3.5px 8px;
  margin-right: 6px;
  top: 5px;
  align-self: flex-end;
  position: absolute;
  background: ${themeGet('colors.primary.100')};
  border-radius: 6px;
`;
